import { defineStore } from "pinia";
 
export const useEventStore = defineStore("eventStore", () => {

  const events = ref([]);

  function initEvents(data) {
    events.value = data;
  }

  function addNewEvent(event) {
    events.value.push(event);
  }

  const router = useRouter();

  async function getEventPaginate(filter) {
      try {
        
        const data = await useNuxtApp().$apiAuth(`/api/event/paginate`,{
          method: 'GET',
          use: 'admin',
          params:{
            ...filter
          }
         })
    
          return {
            success: true,
            data: data?.data,
          };
         
      } catch (error) {
  
        return {
          success: false,
          status: error.response?.status,
          data: null,
        };
      }
    }
    async function getEventPaginateByCategory(filter) {
      try {

        const data = await useNuxtApp().$apiAuth(`/api/event/survey/paginate/`,{
          method: 'GET',
          use: 'admin',
          params:{
            ...filter
          }
         })              
          return {
            success: true,
            data: data?.data
          };
        
      } catch (error) {
 
        return {
          success: false,
          status: error.response?.status,
          contdataent: null,
        };
      }
    }
    async function createEvent(event) {
      try {
 
        const data = await useNuxtApp().$apiAuth(`/api/event/create`,{
          method: 'POST',
          use: 'admin',
          body:{
            ...event
          }
         })
          return {
            success: data?.success,
            data: data?.data,
            errorValidation: {}
          };
       
      } catch (error) {
 
        return {
          success: false,
          status: error.response?.status,
          data: null,
          errorValidation: error?.response?._data?.errors
        };
      }
    }
    async function updateEvent(event) {
      try {
        const data = await useNuxtApp().$apiAuth(`/api/event/update`,{
          method: 'PUT',
          use: 'admin',
          body:{
            ...event
          }
         })
         
          return {
            success: data?.success,
            data: data?.data,
            errorValidation: {}
          };
         
      } catch (error) {
  
        
  
        
        return {
          success: false,
          status: error.response?.status,
          data: null,
          errorValidation: error?.response?._data?.errors
        };
      }
    }
    async function deleteEvent(id) {
      try {
        const data = await useNuxtApp().$apiAuth(`/api/event/delete/${id}`,{
          method: 'DELETE',  
          use: 'admin',    
        })
     
          return {
            success: data?.success,
            data: data?.data,
            errorValidation: {}
          };
      
      } catch (error) {
 
        return {
          success: false,
          status: error.response?.status,
          data: null,
          errorValidation: error?.response?._data?.errors
        };
      }
    }
    async function setEventCache() {
      try {
        const data = await useNuxtApp().$apiAuth(`/api/event/cache/set`,{
          method: 'GET',
          use: 'admin'
         })         
        return {
            success: data?.success,
            data: data?.data,
          };
         
      } catch (error) {
 
        return {
          success: false,
          status: error.response?.status,
          data: null,
        };
      }
    }
    async function getEventCache() {
      try {
        const data = await useNuxtApp().$apiAuth(`/api/event/cache/get`,{
          method: 'GET',
          use: 'admin'
         })         


          return {
            success: true,
            data: data?.data,
          };
        
      } catch (error) {

 
        return {
          success: false,
          status: error.response?.status,
          data: null,
        };
      }
    }
    async function getEventWhenCache() {
      try {
        const data = await useNuxtApp().$apiAuth(`/api/event/when/cache/get`,{
          method: 'GET',
          use: 'admin'
         })
            
          return {
            success: data?.success,
            data: data?.data,
          };
      
      } catch (error) {
 
        return {
          success: false,
          status: error.response?.status,
          data: null,
        };
      }
    }
    async function setEventWhenCache() {
      try {
        const data = await useNuxtApp().$apiAuth(`/api/event/when/cache/set`,{
          method: 'GET',
          use: 'admin'
         })
          return {
            success: true,
            data: data?.data,
          };
        
      } catch (error) {
  
        return {
          success: false,
          status: error.response?.status,
          data: null,
        };
      }
    }
    async function getEventPaginatePublic(filter) {
      try {
        
        const { data } = await useNuxtApp().$apiAxios.get(`/api/event/list/public/paginate`,{
          
          params:{
            ...filter
          }
         })
 
    
          return {
            success: true,
            data: data?.data,
          };
         
      } catch (error) {
  
        return {
          success: false,
          status: error.response?.status,
          data: null,
        };
      }
    }
    async function getByTitle(filter) {
      try {
        
        const {data} = await useNuxtApp().$apiAxios.get(`/api/event/by/title`,{

          params:{
            ...filter
          }
         })
    
          return {
            success: true,
            data: data?.data,
          };
         
      } catch (error) {
  
        return {
          success: false,
          status: error.response?.status,
          data: null,
        };
      }
    }
  return {
    getEventPaginate,
    createEvent,
    updateEvent,
    deleteEvent,
    setEventCache,
    getEventCache,
    getEventWhenCache,
    setEventWhenCache,
    getEventPaginateByCategory,
    getEventPaginatePublic,
    getByTitle
  };
});
